<div class="rounded" >
  <div class="row" (clickOutside)="clickOutside($event)">
    <div class="col-md-12" >
      <svg class="pull-right cursor-pointer me-3"(click)="closePartDrawer()" xmlns="http://www.w3.org/2000/svg" width="24" height="24"
        viewBox="0 0 24 24" fill="none">
        <path
          d="M3.21967 4.28033C2.92678 3.98744 2.92678 3.51256 3.21967 3.21967C3.51256 2.92678 3.98744 2.92678 4.28033 3.21967L12 10.9393L19.7197 3.21967C20.0126 2.92678 20.4874 2.92678 20.7803 3.21967C21.0732 3.51256 21.0732 3.98744 20.7803 4.28033L13.0607 12L20.7803 19.7197C21.0732 20.0126 21.0732 20.4874 20.7803 20.7803C20.4874 21.0732 20.0126 21.0732 19.7197 20.7803L12 13.0607L4.28033 20.7803C3.98744 21.0732 3.51256 21.0732 3.21967 20.7803C2.92678 20.4874 2.92678 20.0126 3.21967 19.7197L10.9393 12L3.21967 4.28033Z"
          fill="black" />
      </svg>
      <h2 class="rfq-heading" placement="top" data-container="body">
        RFQ insights
      </h2>
      <h4 class="top-title">{{rfqName}}</h4>
      <div class="quote-insights-block">
        <h3 class="drawer-title insight-heading text-center">Quote Insights</h3>
        <!-- Show Quote Start -->
        <div *ngIf="showTotalNoQuoteBox" class="quote-card">
            <div class="icon-section">
              <div class="quote-card-icon">
                <img src="/assets/icon/job-icon.svg">
              </div>
              <div class="quote-card-text">
                <h2>Total Quotes<br>on Job</h2>
              </div>
            </div>
            <div class="quote-count">
              <span class="number">{{noOfQuotes}}</span>
              <span class="label">Quotes</span>
            </div>
        </div>
        <div *ngIf="!showTotalNoQuoteBox" class="unlock-quotes total-quotes">
            <a href="#" class="upgrade-link" [routerLink]="['/packages']"> Upgrade to Premium <br> for full access </a>
            <div class="blur-container">
              <div class="quote-card">
                <div class="icon-section">
                  <div class="quote-card-icon">
                    <img src="/assets/icon/job-icon.svg">
                  </div>
                  <div class="quote-card-text">
                    <h2>Total Quotes<br>on Job</h2>
                  </div>
                </div>
                <div class="quote-count">
                  <span class="number">{{noOfQuotes}}</span>
                  <span class="label">Quotes</span>
                </div>
              </div>
            </div>
        </div>
        <!-- Show Quote end -->
         
         <!-- Show lead Time Start -->
         <h3 *ngIf="showLeadTimeBox" class="drawer-title">Lead Time Quoted</h3>
         <div *ngIf="showLeadTimeBox" class="timeline-container" >
          <a href="#" class="upgrade-link"  [routerLink]="['/packages']" > Upgrade to Premium <br> for full access </a>
          <div class="scroll-table">
          <table class="styled-table">
             <thead>
               <tr>
                 <th></th>
                 <th>Min.</th>
                 <th>You</th>
                 <th>Med.</th>
                 <th>Max.</th>
               </tr>
             </thead>
             <tbody>
               <tr *ngFor="let leadTime of leadTimeDetail; let i = index">
                 <th>Qty {{ i + 1 }}</th>
                 <td>{{ leadTime.minLeadTime ? leadTime.minLeadTime + ' Days' : '--' }}</td>
                 <td>{{ leadTime.yoursLeadTime ? leadTime.yoursLeadTime + ' Days' : '--' }}</td>
                 <td>{{ leadTime.medianLeadTime ? leadTime.medianLeadTime + ' Days' : '--' }}</td>
                 <td>{{ leadTime.maxLeadTime ? leadTime.maxLeadTime + ' Days' : '--' }}</td>
               </tr>
             </tbody>
           </table>
          </div>
         </div>
         <h3 *ngIf="!showLeadTimeBox" class="drawer-title">Lead Time Quoted</h3>
         <div *ngIf="!showLeadTimeBox" class="timeline-container unlock-quotes">
          <a href="#" class="upgrade-link"  [routerLink]="['/packages']" > Upgrade to Premium <br> for full access </a>
          <div class="blur-container">
           <table class="styled-table">
             <thead>
               <tr>
                 <th></th>
                 <th>Min.</th>
                 <th>You</th>
                 <th>Med.</th>
                 <th>Max.</th>
               </tr>
             </thead>
             <tbody>
               <tr>
                 <th>Qty 1</th>
                 <td>10 Days</td>
                 <td>10 Days</td>
                 <td>10 Days</td>
                 <td>10 Days</td>
               </tr>
               <tr>
                <th>Qty 2</th>
                <td>10 Days</td>
                <td>10 Days</td>
                <td>10 Days</td>
                <td>10 Days</td>
              </tr>
              <tr>
                <th>Qty 3</th>
                <td>10 Days</td>
                <td>10 Days</td>
                <td>10 Days</td>
                <td>10 Days</td>
              </tr>
             </tbody>
           </table>
          </div>
         </div>
        <!-- Show lead Time End -->

         <!-- Show Pricing Detail Start -->
        <h3 *ngIf="showPricingBox" class="drawer-title">Pricing Details</h3>
        <div *ngIf="showPricingBox" class="timeline-container">
          <div class="scroll-table">
          <table class="styled-table">
            <thead>
              <tr>
                <th></th>
                <th>Min.</th>
                <th>You</th>
                <th>Med.</th>
                <th>Max.</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let price of priceDetail; let i = index">
                <th>Qty {{ i + 1 }}</th>
                <td>{{ price.minPrice != null && price.minPrice !== 0 ? (price.minPrice | currency:'USD':'symbol':'1.2-2') : '--' }}</td>
                <td>{{ price.yoursPrice != null && price.yoursPrice !== 0 ? (price.yoursPrice | currency:'USD':'symbol':'1.2-2') : '--' }}</td>
                <td>{{ price.medianPrice != null && price.medianPrice !== 0 ? (price.medianPrice | currency:'USD':'symbol':'1.2-2') : '--' }}</td>
                <td>{{ price.maxPrice != null && price.maxPrice !== 0 ? (price.maxPrice | currency:'USD':'symbol':'1.2-2') : '--' }}</td>
                
              </tr>
            </tbody>
          </table>
        </div>
        </div>
        <h3 *ngIf="!showPricingBox " class="drawer-title">Pricing Details</h3>
        <div *ngIf="!showPricingBox " class="timeline-container unlock-quotes" >
          <h3 *ngIf="isProfessionalPackage ||(premiumAccount && !showPricingDetails())" class="drawer-title">Unlocked post-RFQ close</h3>
          <a *ngIf="!isProfessionalPackage && !premiumAccount"href="#" class="upgrade-link"  [routerLink]="['/packages']" > Upgrade to Premium <br> for full access </a>
          <div class="blur-container">
          <table class="styled-table">
            <thead>
              <tr>
                <th></th>
                <th>Min.</th>
                <th>You</th>
                <th>Med.</th>
                <th>Max.</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <th>Qty 1</th>
                <td>$ 100</td>
                <td>$ 200</td>
                <td>$ 200</td>
                <td>$ 600</td>
              </tr>
              <tr>
                <th>Qty 2</th>
                <td>$ 100</td>
                <td>$ 200</td>
                <td>$ 200</td>
                <td>$ 600</td>
              </tr>
              <tr>
                <th>Qty 3</th>
                <td>$ 100</td>
                <td>$ 200</td>
                <td>$ 200</td>
                <td>$ 600</td>
              </tr>
            </tbody>
          </table>
          </div>
        </div>
         <!-- Show Pricing Detail end -->

        <!-- Buyer detail start-->
        <h3 *ngIf="showBuyerDetailBox" class="drawer-title">Buyer Details</h3>
        <div *ngIf="showBuyerDetailBox" class="info-card">
          <div class="info-box">
            <div class="info-icon"><img src="/assets/icon/map-pi-area.svg" /></div>
            <div class="info-value">{{distance}}</div>
            <div class="info-label">Miles <br /> away</div>
          </div>
          <div class="info-box">
            <div class="info-icon"><img src="/assets/icon/identificatio-badge.svg" /></div>
            <div class="info-value">{{buyerInsightDetail.memberSince | date: "MMM 'yy" }}</div>
            <div class="info-label">Member <br /> since</div>
          </div>
          <div class="info-box border0">
            <div class="info-icon"><img src="/assets/icon/medal-icon.svg" /></div>
            <div class="info-value">{{buyerInsightDetail.noOfRfqAwarded}}</div>
            <div class="info-label">Jobs <br /> Awarded</div>
          </div>
        </div>
        <h3 *ngIf="!showBuyerDetailBox" class="drawer-title">Buyer Details</h3>
        <div *ngIf="!showBuyerDetailBox" class="info-card unlock-quotes">
          <a href="#" class="upgrade-link" [routerLink]="['/packages']">
            Upgrade to Premium <br />
            for full access
          </a>
          <div class="blur-container">
            <div class="info-box">
              <div class="info-icon"><img src="/assets/icon/map-pi-area.svg" /></div>
              <div class="info-value">242</div>
              <div class="info-label">Miles <br /> away</div>
            </div>
            <div class="info-box">
              <div class="info-icon"><img src="/assets/icon/identificatio-badge.svg" /></div>
              <div class="info-value">June '23</div>
              <div class="info-label">Member <br /> since</div>
            </div>
            <div class="info-box border0">
              <div class="info-icon"><img src="/assets/icon/medal-icon.svg" /></div>
              <div class="info-value">7</div>
              <div class="info-label">Jobs <br /> Awarded</div>
            </div>
          </div>
        </div>
         <!-- Buyer detail end-->
      </div>
    </div>
  </div>
</div>